module.exports = __webpack_public_path__ + "img/facebook-icon.d6c763b8.svg";